export const emojis = [
  'air-kiss',
  'blue-face',
  'blue-face-with-sweat',
  'botanist',
  'bruised-face',
  'crying-face',
  'dazed-face',
  'dejected-face-with-sweat',
  'devil-angry-face',
  'devil-smiling-face',
  'face-in-sunglasses',
  'face-that-makes-you-sick',
  'face-with-rolled-eyes',
  'face-with-smiling-eyes',
  'face-with-tears-of-joy',
  'flushed-face',
  'frowning-face',
  'grinning-face',
  'happy-face',
  'kissing-face',
  'loud-crying-face',
  'neutral-face',
  'pout-face',
  'sleeping-face',
  'slightly-smiling-face',
  'smiling-face-with-big-eyes',
  'smiling-face-with-heart-eyes',
  'squinting-face-with-tongue',
  'stubborn-face',
  'tired-face',
  'winking-face-with-tongue'
]
